document.addEventListener('DOMContentLoaded', (event) => {
  Sceon.ListTypeChanges();
  if (location.search.length == 0) {
    setTimeout(() => {
      $('input[type="checkbox"]').prop('checked', false);
      $('input[type="text"]').val('');

      $('.search-page-form select').val('').trigger('change');
      $('.search-page-form select[name="order"]')
        .val('DEFAULT')
        .trigger('change');
    }, 10);
  }

  $('.show-all-services').on('click', function () {
    if (!$(this).hasClass('collapsed')) {
      $(this).closest('.grid-group').find('.g-item').removeClass('hidden');
      $(this).addClass('collapsed');
    } else {
      $(this).closest('.grid-group').find('.g-item:gt(10)').addClass('hidden');
      $(this).removeClass('collapsed');
    }
  });

  $(
    '.search-page-form input[type="checkbox"], .search-page-form input[type="radio"]',
  ).change(() => {
    checkResetBtn();
  });

  $('.search-page-form input[type="text"]').on('input', () => {
    checkResetBtn();
  });

  $('.search-page-form select:not(#area_id)').on('change', () => {
    checkResetBtn();
  });

  $('#area_id').on('change', function () {
    let area_id = +$(this).val();
    $('#city_id').val('').trigger('change');
    if (area_id && area_id > 0) {
      $('#city_id').find('option').not(':first').attr('disabled', 'disabled');
      $('#city_id')
        .find(`option[data-area-id="${area_id}"]`)
        .removeAttr('disabled');
    } else {
      $('#city_id').find('option').removeAttr('disabled');
    }
    checkResetBtn();
  });
  function checkResetBtn() {
    setTimeout(() => {
      let show = false;
      if ($('.search-page-form input[type="checkbox"]:checked').length) {
        show = true;
      }

      let textInputs = $('.search-page-form input[type="text"]').filter(
        function () {
          return $(this).val() != '';
        },
      );

      let selectInputs = $(
        '.search-page-form select:not([name="order"])',
      ).filter(function () {
        return $(this).val();
      });

      if (textInputs.length) {
        show = true;
      }

      if (selectInputs.length) {
        show = true;
      }

      if (show) {
        $('.reset-btn').removeClass('hidden');
      } else {
        $('.reset-btn').addClass('hidden');
      }
    });
  }

  $(document).on('click', '.reset-btn', function () {
    setTimeout(() => {
      $(this).addClass('hidden');
      $('input[type="checkbox"]').prop('checked', false);
      $('input[type="text"]').val('');

      $('.search-page-form select').val('').trigger('change');
      $('.search-page-form select[name="order"]')
        .val('DEFAULT')
        .trigger('change');
    });
    window.history.pushState({}, null, '?');
    $('html, body').animate(
      {
        scrollTop: 0,
      },
      100,
    );
  });

  checkResetBtn();
});
